<template>
  <header class="header-wrapper">
    <div class="ws-header hd-header-background-color hd-header-color hd-header-fontsize">
      <div class="container ws-header__inner d-flex justify-content-between align-items-center">
        <a href="javascript:void(0)" style="min-width: 100px; min-height: 20px" @click="goToHome()">
          <img
            v-if="airline && airline.template_config && airline.template_config.logo_header_mobile"
            class="ws-logo"
            style="min-width: 100px; min-height: 20px"
            :src="airline.template_config.logo_header_mobile"
            alt="Go to home"
          />
        </a>
        <div style="cursor: pointer">
          <div class="langcode">
            <div id="lang_title" class="lang_title language-option" @click="showLangList = !showLangList">
              <i class="fa fa-language" aria-hidden="true" style="font-size: 32px"></i>
              <span v-if="selectedLanguage"> {{ selectedLanguage }}</span>
            </div>
            <transition v-if="airline.langs && airline.langs.length > 1" name="lang-fade">
              <div v-if="showLangList" class="lang_list">
                <ul>
                  <li
                    v-for="lang in airline.langs"
                    :key="lang.lang_code"
                    :class="lang.lang_code != selectedLanguage ? '' : 'd-none'"
                    @click="changeLang(lang.lang_code)"
                  >
                    <span>{{ lang.name }}</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import '@/assets/scss/modules/Header.scss'

export default {
  name: 'HeaderAirline',
  data() {
    return {
      showLangList: false,
      selectedLanguage: 'en'
    }
  },
  watch: {
    airline: function () {
      if (this.$cookie.get('selected_lang_' + this.airline.id)) {
        this.selectedLanguage = this.$cookie.get('selected_lang_' + this.airline.id)
      }
    }
  },
  created() {
    document.addEventListener('click', (evt) => {
      const flyoutElement = document.getElementById('lang_title')
      let targetElement = evt.target

      do {
        if (targetElement == flyoutElement) {
          return
        }
        targetElement = targetElement.parentNode
      } while (targetElement)
      this.showLangList = false
    })
  },
  methods: {
    changeLang: function (langCode) {
      this.$cookie.set('selected_lang_' + this.airline.id, langCode, true)
      this.selectedLanguage = langCode
      location.reload()
    },
    goToHome: function () {
      location.reload()
    }
  }
}
</script>
